module.exports = __webpack_public_path__ + "static/media/person-icon.53e76baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/person-icon.png
// module id = 366
// module chunks = 0